import { Accordion } from '~/components/Accordion'
import { useRouteLoaderData, Link as RemixLink } from '@remix-run/react'

type SubMenu = {
  fields: {
    label: string
    link: string
  }
}

type Menu = {
  fields: {
    title: string
    links: SubMenu[]
  }
}

type FooterMenuLink = {
  fields: {
    menus: Array<Menu>
  }
}

export const FooterMenu = () => {
  const {
    data: { FooterNav },
  } = useRouteLoaderData('root') as { data: { FooterNav: FooterMenuLink } }
  return (
    <div className="flex flex-grow w-full gap-3 xl:pb-0 lg:gap-16 justify-end max-xl:border-b max-xl:border-neutral-80 pb-4 max-lg:mb-8 max-lg:mt-8 max-lg:flex-col">
      {FooterNav.fields.menus.map((menu: Menu) => {
        const {
          fields: { title, links },
        } = menu
        return (
          <div key={title}>
            <div className="flex lg:hidden">
              <Accordion title={title} defaultOpen={true}>
                <FooterContent links={links} />
              </Accordion>
            </div>
            <div className="hidden lg:flex flex-col gap-3">
              <h3 className="text-s">{title}</h3>
              <FooterContent links={links} />
            </div>
          </div>
        )
      })}
    </div>
  )
}

const FooterContent = ({ links }: { links: SubMenu[] }) => {
  return (
    <>
      {links?.map((subMenu: SubMenu, index: number) => {
        const { label, link } = subMenu.fields
        return (
          <RemixLink key={index} to={link} className="text-neutral-40 w-fit text-xs max-md:block">
            {label}
          </RemixLink>
        )
      })}
    </>
  )
}
